<template>
  <div class="t1">
    <nav_list></nav_list>
    <div class="t0tit">
      {{$lang(52487)}}
    </div>

    <el-row class="elrwo">
      <el-col :span="8">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span><i class="el-icon-user"></i> {{$lang(52635)}}</span>

          </div>
          <div class="box_con longz " style="text-align:left" >
            <el-collapse v-model="activeNames" @change="handleChange">
              <el-collapse-item v-for="(itm, i) in qa" :title="itm[cur_lang() + '_tit']" :name="i" :key="i">
                <div v-html="itm[cur_lang()]"> </div>
              </el-collapse-item>

            </el-collapse>
          </div>
        </el-card>

      </el-col>


      <el-col :span="8">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span><i class="el-icon-user"></i> {{$lang(52488)}}</span>

          </div>
          <div class="box_con">
            <img class="cusimg" :src="cnf.cus_wxqr1.paths.cover" alt="">
            <div class="tit">
              {{cnf.cus_wx1.value}}
            </div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="8">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span><i class="el-icon-user"></i> {{$lang(52488)}}</span>

          </div>
          <div class="box_con">
            <img class="cusimg" :src="cnf.cus_wxqr2.paths.cover" alt="">
            <div class="tit">
              {{cnf.cus_wx2.value}}
            </div>
          </div>
        </el-card>
      </el-col>


    </el-row>

    <el-row class="elrwo">

      <el-col :span="8">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span> <i class="el-icon-edit"></i> {{$lang(52491)}}</span>

          </div>
          <div class="box_con">
            <el-input v-model="fd.tel" :placeholder="$lang(52495)"></el-input>
            <br />
            <br />
            <el-input type="textarea" :rows="9" v-model="fd.cont" :placeholder="$lang(52493)"></el-input>
            <br />
            <br />
            <el-button @click="sbmt"> {{$lang(50133)}}</el-button>
            <br />
            <br />
          </div>
        </el-card>
      </el-col>

    <el-col :span="8" v-if="0">
<el-card class="box-card" >
  <div slot="header" class="clearfix">
    <span> <i class="el-icon-user"></i> {{$lang(52488)}}</span>

  </div>
  <div class="box_con">
    <img class="cusimg" :src="cnf.cus_wxqr1.paths.cover" alt="">
    <div class="tit">
      {{cnf.cus_wx1.value}}
    </div>
  </div>
</el-card>
    </el-col>


      <el-col :span="16">
        <el-card class="box-card ">

          <div class="box_con2 box33">
              <div v-html="cnf['cus_txt_' + cur_lang()].value">

              </div>

          </div>
        </el-card>
      </el-col>


    </el-row>








      <!-- <iframe class="ifr" src="https://w102.ttkefu.com/k/linkurl/?t=3B1FEI1" frameborder="0"></iframe> -->

    <div style=" text-align: center;">
      <el-button class="btnz" @click="jump('/')">{{ $lang(51494)}} </el-button>
    </div>




  </div>
</template>

<script>


import nav_list from '../index/nav_list.vue';
export default {
  name: "bus_list",

  components: {
    nav_list,
  },

  data() {
    return {

      cnf : {},
      fd : {
        tel : '',
        cont : '',
      },
      qa: [],

    };
  },
  mounted(e) {
    document.title = this.web_tit;
    this.f5()
  },

  methods: {
    zx(){
      window.open("https://w102.ttkefu.com/k/linkurl/?t=3B1FEI1", "_blank");
    },
    f5() {
      this.get("/index/ser", {},).then((e) => {
        this.cnf = e.list
        this.qa = e.qa
      });
    },
    sbmt() {
      this.get("/index/fdbk", this.fd, 'post').then((e) => {
        this.$message(this.$lang(50132))

      });
    },

  }
}
</script>
<style scoped>
.box33 {
  min-height: 42vh;
  padding-left: 10%;
  padding-top: 2%;

}

.longz {
  overflow-y: scroll;
}

.longz::-webkit-scrollbar {
  width: 7px;
  height: 7px;
  background-color: #f5f5f5;
}

.longz::-webkit-scrollbar-thumb {
  border-radius: 10px;
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
  background-color: #c8c8c8;
}

.longz::-webkit-scrollbar-corner {

  background-color: black;

}

.longz::-webkit-scrollbar-button {

  background-color: rgb(189, 45, 45);
  color: #f5f5f5;
  display: none;
}

.longz::-webkit-scrollbar-track {

  box-shadow: inset 0 0 1px rgba(0, 0, 0, 0.3);
  -webkit-box-shadow: inset 0 0 1px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  background-color: #f5f5f5
}

.box-card {
  width: 90%;
  margin: auto;
}.cusimg {
  width: 300px;
  height: auto;
}

.elrwo {
  margin: auto;
  margin-top: 40px;
  width: 90%;
}
.box_con {
  height: 350px;
}
.box_con2 .txt {
  margin-top: 10px;
}
.box_con {
  text-align: center;
}
.ifr {
  width: 100%;
  height: 800px;
}
.sel3 {

  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  align-items: center;
}

.labe2 {

  height: 26px;
  line-height: 26px;
  border-radius: 8px;
  margin-right: 1%;
  margin-top: 2%;
  flex: 0 0 28%;
  padding: 0px 4px;
  white-space: nowrap;
  overflow: hidden;
  text-align: center;
  color: #000;
  border: 1px solid #fff;
}

.labe1 {
  background-color: #fff;
}

.labe_act {
  color: #fff;
  background: rgb(4, 100, 221);
}

.p2 {
  width: 70%;
  margin: auto;
  background: #1a54a2;
  padding: 40px;
  text-align: center;
}

.l1 {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;

}

.btnz {
  margin-top: 40px;
}

.tit1 {
  padding: 11px 15px 10px;
  color: #fff;

  font-size: 15px;
  font-weight: bold;
  line-height: 1.6;
}

.ttt2 {
  text-align: left;
  flex: 0 0 50%;
}

.t1 {
  width: 80vw;
  margin: auto;
}

.t0tit {
  margin: 30px auto;
  text-align: center;
  height: 80px;
  line-height: 80px;
  font-size: 30px;
  font-weight: bold;
}


.itm {
  margin-top: 100px;
}

.tit {
  padding: 11px 15px 10px;
  background: #1a54a2;
  color: #fff;
  font-size: 15px;
  font-weight: bold;
  line-height: 1.6;
}

.box {
  padding: 20px;
  border: solid 2px #dadada;
  background: #fff;
  overflow: hidden;
  display: flex;
  align-content: center;
  align-items: center;

}

.box .pic_bustypebox {

  width: 100%;
  font-size: 90%;
  border-collapse: collapse;
  border-spacing: 0;
  margin-bottom: 20px;
}

.box td,
th {


  border: 1px solid #eee;
  padding: 5px 0px;
}

.box .tab {
  flex: 0 0 40%;
}

.box .rigimg {
  flex: 0 0 60%;
}

.desc {
  padding: 18px;
  line-height: 1.8;
  border: solid 2px #dadada;
}

.rigimg img {
  width: 100%;
}

.banner {
  border: solid 2px #dadada;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  padding: 18px;
}

.banner img {
  width: 25%;
  margin-left: 2%;
}

.btn1 {
  margin: 20px auto;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/pages/index/ser.vue